import React from 'react';
import LoadingImg from '../../images/animacion2[18].gif';

const LoadingOverlayFullScreen = (props) => 
            <div className="overlay-fullScreen" style={props.style}
                tabIndex={-1} role="dialog" aria-labelledby="loadingPagesTitle" data-backdrop="static">
              <div className="overlay-content">
                <div>
                  <img draggable={false} src={LoadingImg} alt="Cargando" />
                  <h3>ACHS Virtual</h3>
                </div>                
              </div>
            </div>

export default LoadingOverlayFullScreen